module.exports = __webpack_public_path__ + "static/media/document.d98dc3e6.svg";